var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgricultureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#fff",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 52a14.36 14.36 0 0 0-1.275-5.787 14.479 14.479 0 0 0-3.509-4.797l-4.149-3.737a13.398 13.398 0 0 1-3.252-4.486 13.29 13.29 0 0 1-1.148-5.405c0-7.296 5.97-13.288 13.333-13.288s13.333 5.99 13.333 13.287c0 3.751-1.598 7.365-4.4 9.89l-4.15 3.737a14.484 14.484 0 0 0-3.51 4.797A14.369 14.369 0 0 0 32 52Zm0-19.887a4.06 4.06 0 0 1-2.857-1.172 3.984 3.984 0 0 1-1.183-2.83c0-1.063.425-2.08 1.183-2.831A4.06 4.06 0 0 1 32 24.107c1.072 0 2.1.422 2.857 1.173a3.984 3.984 0 0 1 1.183 2.83c0 1.062-.425 2.08-1.183 2.83A4.06 4.06 0 0 1 32 32.114Z",
    stroke: "url(#a)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 18.667,
    y1: 33.25,
    x2: 45.333,
    y2: 33.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgricultureIcon);
export default __webpack_public_path__ + "static/media/agricultureIcon.f2bf53cf3619c2ee246dda1df2872706.svg";
export { ForwardRef as ReactComponent };